<template>
    <header>
        <nav class="navbar navbar-expand-lg navbar-light bg-dark">
            <a class="navbar-brand" href="/" target="_blank" title="Abrir o site em uma nova aba">Kadu Barman</a>
            <!--<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidebar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>-->
            <div class="collapse navbar-collapse">
                <div class="navbar-nav ml-auto">
                    <div id="user" class="nav-item dropdown">
                        <a href="#" id="dropdown-header-user" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img class="rounded-circle" :src="`${base_url}/storage/upload/users/${userLogged.img}`" alt="">
                            {{userLogged.name}}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a href="" class="dropdown-item" @click.prevent="logout"><i class="fa fa-sign-out-alt"></i> Sair</a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
    import {mapGetters} from 'vuex'
    import env from '../../env';
    import * as request from '../../http';
    export default {
        name: "Header",
        data () {
            return {
                base_url: env.url_api,
            }
        },
        computed: {
            ...mapGetters([
                'userLogged',
                'statusBar'
            ])
        },
        methods: {
            logout () {
                request.get(`${env.url_api}/api/auth/logout`).then((result) => {
                    this.$router.push({ name: 'adm.login'})
                })
            },
            shortenBar() {
                this.$store.commit('TOGGLE_STATUS_BAR');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/sass/variables";
    header{
        .navbar {
            line-height: 1;
            z-index: 1;
            padding: 0;

            &.bg-dark {
                background-color: $primary-site !important;
            }
            .navbar-brand {
                font-size: 22px;
                font-weight: bold;
                padding:15px;
            }
            #user {
                float: right;
                #dropdown-header-user {
                    cursor: pointer;
                    padding:5px;
                    margin: 0;
                    &:hover{
                        background: darken($primary-site, 5%);
                        color: #FFF;
                    }
                    img {
                        width: 40px;
                        height: 40px;
                    }
                }
                .dropdown-menu{
                    a.dropdown-item{
                        padding: 10px;
                    }
                }
            }
        }
    }
</style>
